"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const material_1 = require("@mui/material");
const react_1 = require("react");
const log_context_1 = require("../../../context/log-context");
const log_1 = require("../../../model/log");
exports.AudioButton = (0, react_1.memo)(({ onClick, isPlaying }) => {
    const theme = (0, material_1.useTheme)();
    const { logEvent } = (0, log_context_1.useLog)();
    const handleOnClick = (0, react_1.useCallback)(() => {
        logEvent(log_1.LogEventType.Click, isPlaying
            ? log_1.LogEventClickName.PassageAudioPause
            : log_1.LogEventClickName.PassageAudioPlay);
        onClick();
    }, [logEvent, isPlaying, onClick]);
    return ((0, jsx_runtime_1.jsx)(material_1.Fab, { onClick: handleOnClick, color: "secondary", style: {
            position: "fixed",
            bottom: theme.spacing(4),
            right: theme.spacing(4),
        }, children: isPlaying ? ((0, jsx_runtime_1.jsx)(icons_material_1.Pause, { fontSize: "large", style: {
                color: theme.palette.primary.contrastText,
            } })) : ((0, jsx_runtime_1.jsx)(icons_material_1.PlayArrow, { fontSize: "large", style: {
                color: theme.palette.primary.contrastText,
            } })) }));
});
exports.AudioButton.displayName = "AudioButton";
